/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Border_Style_LabelInputs */

const en_video_export_border_style_label = /** @type {(inputs: Video_Export_Border_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Border Style`)
};

const fr_video_export_border_style_label = /** @type {(inputs: Video_Export_Border_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style de bordure`)
};

const de_video_export_border_style_label = /** @type {(inputs: Video_Export_Border_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rahmenstil`)
};

const it_video_export_border_style_label = /** @type {(inputs: Video_Export_Border_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile del bordo`)
};

const ru_video_export_border_style_label = /** @type {(inputs: Video_Export_Border_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стиль границы`)
};

const es_video_export_border_style_label = /** @type {(inputs: Video_Export_Border_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de borde`)
};

const zh_cn2_video_export_border_style_label = /** @type {(inputs: Video_Export_Border_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`边框样式`)
};

const ja_video_export_border_style_label = /** @type {(inputs: Video_Export_Border_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`境界線のスタイル`)
};

const hi_video_export_border_style_label = /** @type {(inputs: Video_Export_Border_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बॉर्डर शैली`)
};

const pt_pt2_video_export_border_style_label = /** @type {(inputs: Video_Export_Border_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de borda`)
};

/**
* | output |
* | --- |
* | "Border Style" |
*
* @param {Video_Export_Border_Style_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_border_style_label = /** @type {((inputs?: Video_Export_Border_Style_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Border_Style_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_border_style_label(inputs)
	if (locale === "de") return de_video_export_border_style_label(inputs)
	if (locale === "it") return it_video_export_border_style_label(inputs)
	if (locale === "ru") return ru_video_export_border_style_label(inputs)
	if (locale === "es") return es_video_export_border_style_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_border_style_label(inputs)
	if (locale === "ja") return ja_video_export_border_style_label(inputs)
	if (locale === "hi") return hi_video_export_border_style_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_border_style_label(inputs)
	return en_video_export_border_style_label(inputs)
});